
import imgHome1 from "../../../assets/Group 28 (2).png"
import imgHome2 from "../../../assets/Group 28.png"
import imgHome3 from "../../../assets/Group 28 (1).png"

export const USE_CASES = [
    
    {
        useCaseButton:"USECASES",
        title:"Bloggers & Authors",
        description:"Conceptualize fresh topics, write with precision, and ensure the originality of every piece you publish.(Books, Blogs, Social Media, Emails and Ads for Plagarism, Grammar and creation)",
        useCasesImages:imgHome1
    },
    {
        useCaseButton:"USECASES",
        title:"Academics & Students",
        description:"Draft research papers with confidence. Ensure clarity, correctness, and originality in every submission. Research papers, Assignments and plagiarism, grammar check as well as content creation)",
        
        useCasesImages:imgHome2
    },
    {
        useCaseButton:"USECASES",
        title:"Corporate Professionals",
        description:"From internal memos to external PRs, maintain brand voice, accuracy, and distinctiveness. (Internal documents like Customer support, PRD, Sales collaterals, Marketing Collaterals and Emails as well as documents to show in the standup calls)",
        getStartedButton:"Get Started",
        getStartedButtonRoute: "/new-sign-up",
        useCasesImages:imgHome3
    }
]